import { useCallback } from "react";

import { useAsyncCall, useMutation } from "hooks";

export function useCreateSubscription() {
  const [call, loading] = useAsyncCall();

  const mutationFactory = useCallback(() => {
    const query = `
      mutation createSubscription($cardTokenId: String!, $cbPlanId: String!, $billingAddress: BillingAddressInput!, $coupons: [String]) {
        createSubscription(cardTokenId: $cardTokenId, cbPlanId: $cbPlanId, billingAddress: $billingAddress, coupons: $coupons)  {
            successMessage
          }
      }`;

    const resolver = (resp) => {
      return resp;
    };

    return { query, resolver };
  }, []);

  const mutation = useMutation(mutationFactory);

  const createSubscription = async ({ token, plan, coupons, billingInfo }) => {
    const parseError = (e) => {
      if (Array.isArray(e))
        return {
          message: e
            .map(({ message }) => {
              return message || "";
            })
            .join(),
        };

      return e?.[0] || e || {};
    };

    const createError = ({ message }, options) => {
      const defaultMessage = `Sorry, we cannot process your subscription, 
        please reach out to our support team for further assistance`;

      const e = new Error(message || defaultMessage, options);
      e.name = "CreateSubscriptionError";

      return e;
    };

    return call(async () => {
      const resolveMutation = async () => {
        try {
          const { data, errors } = await mutation({
            cardTokenId: token,
            cbPlanId: plan,
            coupons: coupons,
            billingAddress: billingInfo,
          });

          if (errors) {
            return { error: createError(parseError(errors)) };
          }

          return { data };
        } catch (e) {
          const { message } = parseError(e?.response?.data?.errors);
          return { error: createError({ message }, { cause: e }) };
        }
      };

      const { data, error } = await resolveMutation();

      if (error) throw error;
      return data;
    });
  };

  return [createSubscription, loading];
}

export default useCreateSubscription;
